<template>
  <div id="lisProject-edit">

      <IForm :label-width="110" ref="formInline" :model="edit" :elem="editElem" :rules="editRule" :submit="false"  @on-submit="toSubmit">
        <div slot="extend">
          <Row>
            <Col span="12">
              <FormItem label="名称" prop="name">
                <Input v-model="edit.name" type="text" placeholder="请输入名称" maxlength="50"/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="编码" prop="code">
                <Input v-model="edit.code" type="text" placeholder="请输入编码" maxlength="50"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="类型" prop="type">
                <Select v-model="edit.type" style="width: 100%;">
                  <Option v-for="item in  enums.lisTypes" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="价格" prop="price">
                <Input v-model="edit.price" type="text" placeholder="请输入价格" maxlength="10"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="抽血试管" prop="bloodTubeId">
                <Select v-model="edit.bloodTubeId" style="width: 100%;">
                  <Option v-for="item in bloodTubeList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="金域标本子码" prop="subCode">
                <Input v-model="edit.subCode" type="text" placeholder="请输入金域标本子码" maxlength="50"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="状态" prop="status">
                <Select v-model="edit.status" style="width: 100%;">
                  <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="备注" prop="remark">
                <Input v-model="edit.remark" type="textarea" placeholder="请输入备注" :rows="3"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem label="项目告知书">
                <el-upload action="#" :limit="1" :file-list="fileList" list-type="picture-card" :auto-upload="false"
                           :class="{ hideUpload: hideUpload }" :on-change="handleChange"
                           :on-preview="handlePreview" :on-remove="handleRemove" :before-upload="beforeAvatarUpload">
                  <i class="el-icon-plus avatar-uploader-icon"/>
                  <div slot="tip" class="el-upload__tip">只能上传png/jpg/jpeg文件，且大小不超过500MB</div>
                </el-upload>
                <Modal v-model="dialogVisible" width="50%" title="预览" :styles="{'top':'60px'}" :footerHide="true">
                  <img style="display: block; max-width: 100%; margin: 0px auto;" :src="dialogImageUrl">
                </Modal>
              </FormItem>
            </Col>
          </Row>

        </div>

      </IForm>
  </div>
</template>
<script>
import {_get, _save } from "@/services/screeningConfig/lisProject.js";
import {enums} from "@/services/enums";

export default {
  name: "LisProjectEdit",
  props:{
    inspectOrganizeList:{
      type:Array,
      default:()=>{
        return []
      }
    },
    bloodTubeList:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  data() {
    return {
      edit: {
        name: "",
        code: "",
        price: "0.00",
        bloodTubeId: "",
        subCode: "",
        type: "",
        inspectOrganizeId: "",
        remark: "",
        status: 1
      },
      fileList: [],
      hideUpload: false,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      init: "",
      enums: enums,
      editElem: [],
      editRule: {
        name: [
          {required: true, message: '名称不能为空', trigger: 'blur'},
          {maxlength:50,message:"名称长度不能超过50",trigger: 'blur'}
        ],
        code: [
          {required: true, message: '编码不能为空', trigger: 'blur'}
        ],
        price: [
          {required: true, message: '价格不能为空', trigger: 'blur'}
        ],
        bloodTubeId: [
          {
            required: true,
            message: "请选择抽血试管",
            trigger: "change",
            type:'number'
          }
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
            type:'number'
          }
        ],
        inspectOrganizeId: [
          {
            required: true,
            message: "请选择送检机构",
            trigger: "change",
            type:'number'
          }
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
            type:'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
      this.fileList = [];
      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
      if(this.inspectOrganizeList && this.inspectOrganizeList.length > 0){
        this.edit.inspectOrganizeId = this.inspectOrganizeList[0].value;
      }
    },
    handleEdit(row) {
      _get({id: row.id}).then(res =>{
        this.edit = Object.assign({}, res.data);
        if(this.edit.notices){
          this.fileList = [{name: this.edit.noticesFileName, url: this.edit.notices}];
        }
        this.hideUpload = this.fileList.length >= 1;
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      if(this.fileList && this.fileList.length > 0 && this.fileList[0].raw){
        this.edit.file = this.fileList[0].raw;
      }
      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    handleChange(file, fileList){
      this.fileList = fileList;
      this.dialogImageUrl = file.url;
      this.hideUpload = fileList.length >= 1;
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.dialogImageUrl = "";
      this.edit.notices = "";
      this.hideUpload = fileList.length >= 1;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpeg';
      const isLt500M = file.size / 1024 / 1024 < 500;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 PNG/JPG/JPEG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 500MB!');
      }
      return isJPG && isLt500M;
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/.ivu-input[disabled], fieldset[disabled] .ivu-input {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/deep/.ivu-checkbox-disabled+span {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/deep/.el-input.is-disabled .el-input__inner {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/deep/.ivu-select-disabled .ivu-select-selection {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/* 隐藏上传按钮 */
.hideUpload /deep/ .el-upload--picture-card {
  display: none !important;
}

</style>
